import { logger } from "../utils/utils";
import api from "./apis/api";

class CaskAndAgingService {
  createCaskAndAging(payload) {
    logger("CaskAndAgingService", "createCaskAndAging");
    return api.caskandaging.createCaskAndAging(payload);
  }

  updateCaskAndAging(payload) {
    logger("CaskAndAgingService", "updateCaskAndAging");
    return api.caskandaging.updateCaskAndAging(
      payload?.caskAndAgingId,
      payload?.payload,
    );
  }

  getCaskAndAgingList(payload) {
    logger("CaskAndAgingService", "getCaskAndAgingList");
    return api.caskandaging.getCaskAndAgingList(payload);
  }

  getCaskAndAgingById(caskAndAgingId) {
    logger("CaskAndAgingService", "getCaskAndAgingById");
    return api.caskandaging.getCaskAndAgingById(caskAndAgingId);
  }

  createSamplinglogs(payload) {
    logger("CaskAndAgingService", "createSamplinglogs");
    return api.caskandaging.createSamplinglogs(payload);
  }

  updateSamplinglogs(payload) {
    logger("CaskAndAgingService", "updateSamplinglogs");
    return api.caskandaging.updateSamplinglogs(
      payload?.samplingLogsId,
      payload?.payload,
    );
  }

  getSamplinglogsList(payload) {
    logger("CaskAndAgingService", "getSamplinglogsList");
    return api.caskandaging.getSamplinglogsList(payload);
  }

  getCaskOpenLogsList(payload) {
    logger("CaskAndAgingService", "getCaskOpenLogsList");
    return api.caskandaging.getCaskOpenLogsList(payload);
  }

  createCaskOpenLogs(payload) {
    logger("CaskAndAgingService", "createCaskOpenLogs");
    return api.caskandaging.createCaskOpenLogs(payload);
  }

  updateCaskOpenLogs(payload) {
    logger("CaskAndAgingService", "updateCaskOpenLogs");
    return api.caskandaging.updateCaskOpenLogs(
      payload?.caskOpenLogId,
      payload?.payload
    );
  }

  getCaskOpenLogsById(caskOpenLogId) {
    logger("CaskAndAgingService", "getCaskOpenLogsById");
    return api.caskandaging.getCaskOpenLogsById(caskOpenLogId);
  }

  deleteCaskOpenLogs(caskOpenLogId) {
    logger("CaskAndAgingService", "deleteCaskOpenLogs");
    return api.caskandaging.deleteCaskOpenLogs(caskOpenLogId);
  }
}

export default new CaskAndAgingService();
